import React from "react";

const Java_Wrapper = () => {
  return (
    <div>
      <h1>Java Wrapper</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Wrapper in Java.</p>
    </div>
  );
};

export default Java_Wrapper;
